import * as React from 'react'

import {
  SUPPORTED_FEATURES,
  useFeatureFlags,
} from '@thg-commerce/enterprise-core'
import { ProductButton as GravityProductButton } from '@thg-commerce/gravity-elements'
import { ProductButtonProps as GravityProductButtonProps } from '@thg-commerce/gravity-elements/Product/ProductButton/ProductButton'

import { useQuickBuyClickHandler } from './hooks'

export type ProductButtonProps = GravityProductButtonProps & {
  quickBuyTitle: string
  productSku: string
}

export const ProductButton = ({
  quickBuyTitle,
  ...props
}: ProductButtonProps) => {
  const quickBuyClickHandler = useQuickBuyClickHandler(props.productSku)
  const quickBuyFeatureEnabled = useFeatureFlags([
    SUPPORTED_FEATURES.PREVIEW_QUICKBUY,
  ])

  return (
    <GravityProductButton
      {...props}
      title={quickBuyFeatureEnabled ? quickBuyTitle : props.title}
      onClick={quickBuyFeatureEnabled ? quickBuyClickHandler : undefined}
    />
  )
}
